import React from 'react';
import ReactMapboxGl, { Layer, Feature } from 'react-mapbox-gl';
import settings from 'front-settings';

const Map = ReactMapboxGl({
  accessToken: settings.MAPBOX_ACCESS_TOKEN,
  maxZoom: 21,
  minZoom: 8,
});

const DEFAULT_PAINT = {
  'fill-color': '#000000',
  'fill-opacity': 0.25,
};
const SELECTED_PAINT = {
  'fill-color': '#000000',
  'fill-opacity': 0.8,
};

export const ZonesViewRender = ({ zones, center, zoom, selectZone, selectedZone }) => (
  <div>
    <p>Cliquez sur une zone pour afficher l'agent concerné</p>
    <Map
      style="mapbox://styles/makinacorpus/cjpchq1n03xeb2rqrmw59tmmm" // eslint-disable-line react/style-prop-object
      containerStyle={{
        height: '30rem',
        width: '100%',
      }}
      center={center}
      zoom={[zoom]}
    >
      {/* Unselected zones */}
      <Layer
        type="fill"
        paint={DEFAULT_PAINT}
      >
        {zones.features
          .filter(({ properties: { tmpId } }) =>
            !selectedZone || tmpId !== selectedZone.properties.tmpId)
          .map(({ geometry: { coordinates }, properties }) => (
            <Feature
              key={JSON.stringify(coordinates)}
              coordinates={coordinates}
              properties={properties}
              onClick={selectZone}
            />
          ))
        }
      </Layer>
      {/* Selected zone */}
      <Layer
        type="fill"
        paint={SELECTED_PAINT}
      >
        {zones.features
          .filter(({ properties: { tmpId } }) =>
            selectedZone && tmpId === selectedZone.properties.tmpId)
          .map(({ geometry: { coordinates }, properties }) => (
            <Feature
              key={JSON.stringify(coordinates)}
              coordinates={coordinates}
              properties={properties}
              onClick={selectZone}
            />
          ))
        }
      </Layer>
    </Map>
  </div>
);

export default ZonesViewRender;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/ZonesView/render.js